import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AddcameradialogComponent } from '../Gm-Dashboard/addcameradialog/addcameradialog.component';

@Component({
  selector: 'app-input-alert',
  templateUrl: './input-alert.component.html',
  styleUrls: ['./input-alert.component.scss']
})
export class InputAlertComponent implements OnInit{

channelName: any;
  message: any;
constructor(private dialogRef:MatDialogRef<AddcameradialogComponent> , @Inject(MAT_DIALOG_DATA) public data: any){}
  ngOnInit(): void {
    this.message=this.data;
  }
getChannelName(event:any){
  this.channelName=event.target.value
}
buttonClose(){
  this.dialogRef.close(this.channelName);
}
}
